import apiPath from '../../../config/api';

const PurchaseSalesPath = {
    title: "Permata - Pembelian dan Penjualan",
    basePath: "/permata/jual-beli",
    base: apiPath.retailPurchaseSales,
    purchaseSalesExcel: apiPath.retailPurchaseSalesExcel,
    purchaseSalesFind: apiPath.retailPurchaseSalesFind
}

export default PurchaseSalesPath;
